var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 56,
    viewBox: "0 0 67 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "triangle_bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6378 3.17697C30.7876 -0.281645 36.2123 -0.281645 38.3621 3.17697L66.0455 47.7141C68.1788 51.1461 65.4832 55.4164 61.1834 55.4164H5.81657C1.51678 55.4164 -1.17887 51.1461 0.954422 47.7141L28.6378 3.17697Z",
    fill: "url(#paint0_linear_2061_2446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M33.5 18.208V31.9125",
    stroke: "white",
    strokeWidth: 3.91667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 47.5833C35.6631 47.5833 37.4166 45.8298 37.4166 43.6667C37.4166 41.5036 35.6631 39.75 33.5 39.75C31.3369 39.75 29.5833 41.5036 29.5833 43.6667C29.5833 45.8298 31.3369 47.5833 33.5 47.5833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2061_2446",
    x1: 33.9583,
    y1: -4.50049,
    x2: 33.9583,
    y2: 60.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.372265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF3",
    stopOpacity: 0.250978
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8b65a67c7af97a8476dae200e8f87f93.svg";
export { ForwardRef as ReactComponent };